import React from 'react';
import { Link } from 'react-router-dom';

import Brooke from '../../images/Home/brooke.png';
import Rayul from '../../images/Home/rayul.png';

import './styles.scss';


class Main extends React.Component {
  render() {
    return (
      <div className="main__container">
        <div class="left__container">
          <img class="left__image" src={Brooke} alt="Telephone" />
          <div className="text__container">
            <div class="text__container__one">
              <h3 class="left__text__one">Inigualable</h3>
            </div>
            <div class="text__container__two">
              <h3 class="left__text__two">Incomparable</h3>
            </div>
            <div class="text__container__three">
              <h3 class="left__text__three">Increíble</h3>
            </div>
          </div>
          <button class="hire__button">
            <Link to="/hires" className="button__link">contrata hoy</Link>
          </button>
        </div>
        <div class="right__container">
          <img class="right__image" src={Rayul} alt="Telephone" />
          <button class="costumer__button">
            <Link to="/ATC" className="button__link">eres cliente y necesitas ayuda</Link>
          </button>
        </div>
      </div>
    );
  }
}

export default Main;
